import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { GET_MANY } from 'react-admin';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Button,
  FormControl,
  TextField,
} from '@material-ui/core';

import dataProvider from '../../dataProvider';

class FetchFolioPrivateQuotesButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      showDialog: false,
      showProgressDialog: false,
      progressContent: '',
      fetchOption: 'single',
      ticker: '',
    };
  }

  handleClick = async () => {
    try {
      if (this.state.isSubmitting) {
        return;
      }
      this.setState({
        isSubmitting: true,
        showDialog: false,
        showProgressDialog: true,
        progressContent: 'Fetching...',
      });
      const { fetchOption, ticker } = this.state;
      const { resource } = this.props;
      if (fetchOption === 'all') {
        await dataProvider(GET_MANY, resource);
      } else {
        await dataProvider('SINGLE_FOLIO_SECURITY', resource, { ticker });
      }
      this.setState({ isSubmitting: false, progressContent: 'Private Quotes fetched successfully' });
    } catch (err) {
      if (err.status === 500 && (err.message.includes('Not Found') || err.message.includes('Bad Request'))) {
        this.setState({ isSubmitting: false, progressContent: 'Private Quote not found' });
        return;
      }
      this.setState({ isSubmitting: false, progressContent: err.message });
    }
  };

  openDialog = () => {
    this.setState({ showDialog: true });
  };

  closeDialog = () => {
    this.setState({ showDialog: false });
  };

  handleRadioChange = (e) => {
    this.setState({ fetchOption: e.target.value });
  };

  handleTickerInput = (e) => {
    this.setState({ ticker: e.target.value });
  };

  render() {
    const { fetchPrivateQuotes, fetchSinglePrivateQuote, ...rest } = this.props;
    const { showDialog, showProgressDialog } = this.state;
    return (
      <Fragment>
        <Button
          onClick={this.openDialog}
          {...rest}
        >Fetch Private Quotes
        </Button>
        <Dialog open={showDialog} fullWidth aria-label="Fetch Private Quotes">
          <DialogTitle>Fetch Private Quotes</DialogTitle>
          <DialogContent>
            <FormControl component="fieldset">
              <TextField
                label="Ticker"
                value={this.state.ticker}
                onChange={this.handleTickerInput}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeDialog} color="primary">Close</Button>
            <Button onClick={this.handleClick} disabled={this.state.ticker.length === 0} color="primary">Get Quotes</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={showProgressDialog} fullWidth aria-label="Private Quotes fetched successfully">
          <DialogContent>
            {this.state.progressContent}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ showProgressDialog: false })} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

FetchFolioPrivateQuotesButton.defaultProps = {
  record: null,
};

const fetchPrivateQuotesAction = resource => ({
  type: 'GET_MANY',
  payload: {
    resource,
  },
  meta: {
    fetch: 'GET_MANY',
    resource,
    refresh: true,
  },
});

const fetchSinglePrivateQuoteAction = (resource, ticker) => ({
  type: 'SINGLE_FOLIO_SECURITY',
  payload: {
    resource,
    ticker,
  },
  meta: {
    fetch: 'SINGLE_FOLIO_SECURITY',
    resource,
    refresh: true,
  },
});

export default connect(null, {
  fetchPrivateQuotes: fetchPrivateQuotesAction,
  fetchSinglePrivateQuote: fetchSinglePrivateQuoteAction,
})(FetchFolioPrivateQuotesButton);



// WEBPACK FOOTER //
// ./src/components/PrivateQuote/fetchFolioPrivateQuotesButton.js